module.exports = __webpack_public_path__ + "bb4d5a91efa35b05af6dba7e4a922594.png";